import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6fb1858e")

_pushScopeId("data-v-6fb1858e")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "icons" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "hours" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_user_in_table = _resolveComponent("user-in-table")
  const _component_icon = _resolveComponent("icon")
  const _component_comment_teleport = _resolveComponent("comment-teleport")

  return (_openBlock(), _createBlock("tr", _hoisted_1, [
    _createVNode(_component_user_in_table, { user: _ctx.user }, null, 8, ["user"]),
    _createVNode("td", {
      colspan: _ctx.hours.length,
      class: "timeline-row",
      ref: "timelineEl",
      onMouseenter: _cache[1] || (_cache[1] = () => (_ctx.isCommentHover = true)),
      onMouseleave: _cache[2] || (_cache[2] = () => (_ctx.isCommentHover = false))
    }, [
      _createVNode("div", _hoisted_2, [
        (_ctx.day && _ctx.dayNotFilled(_ctx.day))
          ? (_openBlock(), _createBlock("span", _hoisted_3, [
              _createVNode(_component_icon, { name: "kaktus" })
            ]))
          : (_openBlock(), _createBlock("span", _hoisted_4, [
              (_ctx.day?.unpaid && _ctx.day?.notAvailableAccepted)
                ? (_openBlock(), _createBlock("span", _hoisted_5, [
                    _createVNode(_component_icon, {
                      name: "not-available",
                      title: "Unpaid absence"
                    }),
                    _createVNode(_component_icon, {
                      name: "thunder",
                      title: "Unpaid absence"
                    })
                  ]))
                : (_ctx.day?.occasionalAbsence && _ctx.day?.notAvailableAccepted)
                  ? (_openBlock(), _createBlock("span", _hoisted_6, [
                      _createVNode(_component_icon, {
                        name: "not-available",
                        title: "Special absence"
                      }),
                      _createVNode(_component_icon, {
                        name: "occasional-absence",
                        title: "Special absence"
                      })
                    ]))
                  : (_ctx.day?.atConference)
                    ? (_openBlock(), _createBlock("span", _hoisted_7, [
                        _createVNode(_component_icon, { name: "course" })
                      ]))
                    : (_ctx.day?.notAvailable && _ctx.day?.notAvailableAccepted)
                      ? (_openBlock(), _createBlock("span", _hoisted_8, [
                          _createVNode(_component_icon, { name: "not-available" })
                        ]))
                      : _createCommentVNode("", true),
              (_ctx.day?.halfNotAvailable)
                ? (_openBlock(), _createBlock("span", _hoisted_9, [
                    _createVNode(_component_icon, {
                      name: "half-day",
                      title: _ctx.halfDayAbsenceMsg(_ctx.day)
                    }, null, 8, ["title"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldDisplayQuestionMark(_ctx.day))
                ? (_openBlock(), _createBlock("span", _hoisted_10, [
                    _createVNode(_component_icon, { name: "absence-in-review" })
                  ]))
                : (_ctx.day?.businessDay && !_ctx.anyUnavailabilityWasMarked(_ctx.day))
                  ? (_openBlock(), _createBlock("span", _hoisted_11, [
                      _createVNode(_component_icon, {
                        name: _ctx.day.remote ? 'remote' : 'office'
                      }, null, 8, ["name"])
                    ]))
                  : _createCommentVNode("", true)
            ])),
        (_ctx.day?.comment || _ctx.day?.halfNotAvailableStartTime)
          ? (_openBlock(), _createBlock("span", _hoisted_12, [
              (_ctx.day.comment)
                ? (_openBlock(), _createBlock(_component_icon, {
                    key: 0,
                    name: "comment"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_comment_teleport, {
                user: _ctx.user,
                day: _ctx.day,
                "is-active": _ctx.isCommentHover
              }, null, 8, ["user", "day", "is-active"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_13, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hours, (hour) => {
          return (_openBlock(), _createBlock("div", {
            key: hour,
            class: "hour"
          }))
        }), 128))
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.periodsToRender, ({ left, width, title, remote }) => {
        return (_openBlock(), _createBlock("div", {
          key: left + width,
          class: ["period", { 'period--remote': remote }],
          style: { left, width },
          textContent: _toDisplayString(title)
        }, null, 14, ["textContent"]))
      }), 128))
    ], 40, ["colspan"])
  ]))
})